import Guard from '@/services/middleware'

const DashLayout = () => import('@/layouts/DashLayout.vue')
const Home = () => import('@/views/dash/automations/Home.vue')

export default [
    {
        path: '/automacoes/',
        component: DashLayout,
        meta: { permission: 2, module:'mod_automation'},
        beforeEnter: [
            Guard.redirectIfNotAuthenticated,
            Guard.checkModuleAccess
        ],
        children: [
            {
                path: '', name: 'automation.home', component: Home, meta: { title: 'Automações', permission: 2, module:'mod_automation' },
            },
            {
                path: ':id?',
                name: 'automation.action',
                component: () => import('@/views/dash/automations/ActionAutomation.vue'),
                meta: { title: 'Ações da Automação',  permission: 2, module:'mod_automation' },
                children: [
                    {
                        path: 'acoes',
                        name: 'automation.action.id',
                        component: () => import('@/views/dash/automations/ActionAutomationId.vue'),
                        meta: { title: 'Ações da Automação', permission: 2, module:'mod_automation' },
                    },
                ],
            },
        ],
    },
]
